var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEShopLogoLarge = function SvgEShopLogoLarge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 289.262,
    height: 161.675,
    viewBox: "0 0 289.262 161.675",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yp1wo9m6ia"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5879",
    style: {
      fill: "none"
    },
    d: "M0 0h289.262v20.076H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3272"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "1O1O-logo"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3208",
    d: "M6.538 86.268H112.98V0H6.538z",
    transform: "translate(85.794)",
    style: {
      fillRule: "evenodd",
      fill: "#ffdc00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1627"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3209",
    d: "M145.247 18.631a72.761 72.761 0 0 0-7.7-3.364c-2.889-1.253-2.61-.6-5.106-2.236-2.285-.957-5.335-.926-7.247-1.843-1.66-.441-3.541-1.749-5.354-.875-1.264-.81-1.87.176-3.886-1.573-.514-.75 6.1.1 6.45.143l.663.086c1.008.239 1.073.8 2.483.711l2.11.66c.746.05 1.264-.5 3.091-.123-2.384-1.107-2.551-.448-3.651-.717l-.937-.555c-.619-.518-2.5-.4-3.482-.744l-.836-.467c-1.218-1.229-3.087-.972-5.618-1.54-2.5-.555-16.572-3.4-20.515-3.9C91.758 1.833 85.471.2 66.989.2a231.768 231.768 0 0 0-53.216 5.887c-6.74 1.534-6.564.186-8.386 1.281-1.407.847-3.692 2.519-3.824 4.388-.336 5.056-.536 4.086-1.463 6.236-.935 2.179 4.922 4.667 7.315 4.537 2.358-.143 2.217-1.4 6.632-3.822 4.382-2.431 8.011-3.2 12.838-4.415 5.934-1.494 11.22-3.359 20.688-4.439.918-.1 2.461.445 3.96.362 14.353-1.687 51.076-.362 71.251 5.5 3.361 1.137-1.065-1-.031-1.172 1.043-.156 2.924.621 4.013.116l.288.459a2.471 2.471 0 0 0 2.577 1.009c2 .467 3.506-.16 4.7 1.082.36-.173 1.245.366 1.269.149-1.873-1.332-3.313-1.553-5.9-2.543 3.5-.371 15.775 3.947 15.547 3.811",
    transform: "translate(84.59 24.82)",
    style: {
      fill: "#939597",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3210",
    d: "M12.885 32.446v-8.188h7.756V51.1h-6.362V32.446z",
    transform: "translate(86.962 8.526)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3211",
    d: "M12.885 32.446v-8.188h7.756V51.1h-6.362V32.446z",
    transform: "translate(86.962 8.526)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3212",
    d: "M39.364 44.391a6.638 6.638 0 1 1 6.65-6.622 6.652 6.652 0 0 1-6.65 6.622m-.031-20.532A13.891 13.891 0 1 0 53.238 37.75a13.887 13.887 0 0 0-13.905-13.891",
    transform: "translate(89.275 8.453)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3213",
    d: "M39.364 44.391a6.638 6.638 0 1 1 6.65-6.622 6.652 6.652 0 0 1-6.65 6.622zm-.031-20.532A13.891 13.891 0 1 0 53.238 37.75a13.887 13.887 0 0 0-13.905-13.891z",
    transform: "translate(89.275 8.453)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3214",
    d: "M80.46 44.391a6.638 6.638 0 1 1 6.645-6.622 6.64 6.64 0 0 1-6.645 6.622m0-20.532A13.891 13.891 0 1 0 94.344 37.75 13.9 13.9 0 0 0 80.46 23.859",
    transform: "translate(96.843 8.453)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3215",
    d: "M80.46 44.391a6.638 6.638 0 1 1 6.645-6.622 6.64 6.64 0 0 1-6.645 6.622zm0-20.532A13.891 13.891 0 1 0 94.344 37.75 13.9 13.9 0 0 0 80.46 23.859z",
    transform: "translate(96.843 8.453)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3216",
    d: "M54.006 32.446v-8.188h7.756V51.1h-6.34V32.446z",
    transform: "translate(94.531 8.526)",
    style: {
      fill: "#1b1d21",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3217",
    d: "M54.006 32.446v-8.188h7.756V51.1h-6.34V32.446z",
    transform: "translate(94.531 8.526)",
    style: {
      strokeWidth: ".5px",
      stroke: "#231f20",
      fillRule: "evenodd",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3218",
    d: "M105.01 3.882h1.39c.746 0 1.445.233 1.445 1.036 0 .9-.562 1.108-1.445 1.108h-1.39zm-1.142 6.176h1.142V6.919h.99l1.952 3.14h1.229l-2-3.14a1.808 1.808 0 0 0 1.835-1.955c0-1.327-.806-1.994-2.435-1.994h-2.711zm-2.568-3.55a4.883 4.883 0 1 1 9.754 0 4.883 4.883 0 1 1-9.754 0zm-1.163 0a6.041 6.041 0 1 0 6.039-6.031 6.055 6.055 0 0 0-6.041 6.032z",
    transform: "translate(103.023 4.148)",
    style: {
      fillRule: "evenodd",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3080"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3078",
    transform: "translate(0 107.486)",
    style: {
      clipPath: "url(#yp1wo9m6ia)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4313",
    d: "M8.456.163A10.58 10.58 0 0 1 10.9.447a12.339 12.339 0 0 1 2.586.967v2.67a12.157 12.157 0 0 0-2.506-1.125 8.287 8.287 0 0 0-2.4-.347 6.111 6.111 0 0 0-2.827.646 4.75 4.75 0 0 0-1.959 1.824A5.029 5.029 0 0 0 3.1 7.7a5.065 5.065 0 0 0 .693 2.638 4.655 4.655 0 0 0 1.955 1.8 6.211 6.211 0 0 0 2.838.636 7.628 7.628 0 0 0 2.307-.347 16.794 16.794 0 0 0 2.769-1.251v2.67a12.816 12.816 0 0 1-2.628 1.061 11.05 11.05 0 0 1-2.8.316 9.077 9.077 0 0 1-4.151-.923 6.945 6.945 0 0 1-2.874-2.664A7.257 7.257 0 0 1 .163 7.825 7.5 7.5 0 0 1 1.24 3.842 7.228 7.228 0 0 1 4.2 1.119 9.268 9.268 0 0 1 8.456.163",
    transform: "translate(-.037 -.037)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4314",
    d: "M8.456.163A10.58 10.58 0 0 1 10.9.447a12.339 12.339 0 0 1 2.586.967v2.67a12.157 12.157 0 0 0-2.506-1.125 8.287 8.287 0 0 0-2.4-.347 6.111 6.111 0 0 0-2.827.646 4.75 4.75 0 0 0-1.959 1.824A5.029 5.029 0 0 0 3.1 7.7a5.065 5.065 0 0 0 .693 2.638 4.655 4.655 0 0 0 1.955 1.8 6.211 6.211 0 0 0 2.838.636 7.628 7.628 0 0 0 2.307-.347 16.794 16.794 0 0 0 2.769-1.251v2.67a12.816 12.816 0 0 1-2.628 1.061 11.05 11.05 0 0 1-2.8.316 9.077 9.077 0 0 1-4.151-.923 6.945 6.945 0 0 1-2.874-2.664A7.257 7.257 0 0 1 .163 7.825 7.5 7.5 0 0 1 1.24 3.842 7.228 7.228 0 0 1 4.2 1.119 9.268 9.268 0 0 1 8.456.163z",
    transform: "translate(-.037 -.037)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4315",
    d: "M25.344 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.618 4.618 0 0 1-1.918-1.808 5.269 5.269 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.753-.636m-2.67 5.056a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.394 3.394 0 0 0-.735 2.281",
    transform: "translate(-4.479 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4316",
    d: "M25.344 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.618 4.618 0 0 1-1.918-1.808 5.269 5.269 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.754-.639zm-2.67 5.056a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.394 3.394 0 0 0-.734 2.281z",
    transform: "translate(-4.479 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4317",
    d: "M42.148 6.437a2.406 2.406 0 0 1 1.015.231 5.729 5.729 0 0 1 1.161.778l-.924 2.26a3.405 3.405 0 0 0-1.808-.842 1.935 1.935 0 0 0-1.182.448 3.185 3.185 0 0 0-.935 1.182 3.381 3.381 0 0 0-.352 1.471v4.478h-2.587V6.626h2.586v2.5h.041a6.844 6.844 0 0 1 1.419-2.055 2.308 2.308 0 0 1 1.566-.636",
    transform: "translate(-8.198 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4318",
    d: "M42.148 6.437a2.406 2.406 0 0 1 1.015.231 5.729 5.729 0 0 1 1.161.778l-.924 2.26a3.405 3.405 0 0 0-1.808-.842 1.935 1.935 0 0 0-1.182.448 3.185 3.185 0 0 0-.935 1.182 3.381 3.381 0 0 0-.352 1.471v4.478h-2.587V6.626h2.586v2.5h.041a6.844 6.844 0 0 1 1.419-2.055 2.308 2.308 0 0 1 1.566-.634z",
    transform: "translate(-8.198 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4319",
    d: "M53.192 6.438a4.381 4.381 0 0 1 3.391 1.408 5.229 5.229 0 0 1 1.288 3.669 5.686 5.686 0 0 1-.6 2.649 4.42 4.42 0 0 1-1.72 1.819 4.9 4.9 0 0 1-2.522.652 5.1 5.1 0 0 1-2.3-.579v5.34h-2.592V6.627H50.7v.631a4.246 4.246 0 0 1 2.49-.82m-2.47 7.725a3.648 3.648 0 0 0 1.807.557 2.429 2.429 0 0 0 1.955-.872 3.373 3.373 0 0 0 .737-2.25 3.773 3.773 0 0 0-.658-2.354 2.218 2.218 0 0 0-1.861-.851 2.539 2.539 0 0 0-.873.153 4.965 4.965 0 0 0-1.1.646z",
    transform: "translate(-10.801 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4320",
    d: "M53.192 6.438a4.381 4.381 0 0 1 3.391 1.408 5.229 5.229 0 0 1 1.288 3.669 5.686 5.686 0 0 1-.6 2.649 4.42 4.42 0 0 1-1.72 1.819 4.9 4.9 0 0 1-2.522.652 5.1 5.1 0 0 1-2.3-.579v5.34h-2.592V6.627H50.7v.631a4.246 4.246 0 0 1 2.492-.82zm-2.47 7.725a3.648 3.648 0 0 0 1.807.557 2.429 2.429 0 0 0 1.955-.872 3.373 3.373 0 0 0 .737-2.25 3.773 3.773 0 0 0-.658-2.354 2.218 2.218 0 0 0-1.863-.851 2.539 2.539 0 0 0-.873.153 4.965 4.965 0 0 0-1.1.646z",
    transform: "translate(-10.801 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4321",
    d: "M68.059 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.618 4.618 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.72 4.72 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.753-.636m-2.67 5.056a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.394 3.394 0 0 0-.735 2.281",
    transform: "translate(-14.064 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4322",
    d: "M68.059 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.618 4.618 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.72 4.72 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.754-.639zm-2.67 5.056a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.394 3.394 0 0 0-.734 2.281z",
    transform: "translate(-14.064 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4323",
    d: "M84.863 6.437a2.406 2.406 0 0 1 1.015.231 5.728 5.728 0 0 1 1.161.778l-.925 2.26a3.405 3.405 0 0 0-1.808-.842 1.935 1.935 0 0 0-1.182.448 3.185 3.185 0 0 0-.935 1.182 3.381 3.381 0 0 0-.352 1.471v4.478h-2.586V6.626h2.586v2.5h.041A6.844 6.844 0 0 1 83.3 7.073a2.308 2.308 0 0 1 1.566-.636",
    transform: "translate(-17.783 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4324",
    d: "M84.863 6.437a2.406 2.406 0 0 1 1.015.231 5.728 5.728 0 0 1 1.161.778l-.925 2.26a3.405 3.405 0 0 0-1.808-.842 1.935 1.935 0 0 0-1.182.448 3.185 3.185 0 0 0-.935 1.182 3.381 3.381 0 0 0-.352 1.471v4.478h-2.586V6.626h2.586v2.5h.041A6.844 6.844 0 0 1 83.3 7.073a2.308 2.308 0 0 1 1.563-.636z",
    transform: "translate(-17.783 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4325",
    d: "M94.195 6.437a4.519 4.519 0 0 1 2.891.8 2.721 2.721 0 0 1 1 2.245v4.8q0 .557.452.558a1.357 1.357 0 0 0 .531-.163 2.377 2.377 0 0 0 .573-.373V15.8a4.841 4.841 0 0 1-2.481.831 2.035 2.035 0 0 1-1.066-.232 1.265 1.265 0 0 1-.52-.82 5.116 5.116 0 0 1-2.975 1.054 2.57 2.57 0 0 1-1.823-.715 2.267 2.267 0 0 1-.762-1.713 2.67 2.67 0 0 1 .756-2.007 6.443 6.443 0 0 1 2.649-1.283l2.092-.609v-.452q0-1.44-1.744-1.44a4.171 4.171 0 0 0-1.776.41 5.047 5.047 0 0 0-1.609 1.208V7.709a5.969 5.969 0 0 1 3.816-1.272m-1.577 7.379a1.135 1.135 0 0 0 .341.862 1.18 1.18 0 0 0 .846.326 2.546 2.546 0 0 0 1.7-.778V11.64a12.06 12.06 0 0 0-1.7.694 3.107 3.107 0 0 0-.9.662 1.212 1.212 0 0 0-.289.82",
    transform: "translate(-20.197 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4326",
    d: "M94.195 6.437a4.519 4.519 0 0 1 2.891.8 2.721 2.721 0 0 1 1 2.245v4.8q0 .557.452.558a1.357 1.357 0 0 0 .531-.163 2.377 2.377 0 0 0 .573-.373V15.8a4.841 4.841 0 0 1-2.481.831 2.035 2.035 0 0 1-1.066-.232 1.265 1.265 0 0 1-.52-.82 5.116 5.116 0 0 1-2.975 1.054 2.57 2.57 0 0 1-1.823-.715 2.267 2.267 0 0 1-.762-1.713 2.67 2.67 0 0 1 .756-2.007 6.443 6.443 0 0 1 2.649-1.283l2.092-.609v-.452q0-1.44-1.744-1.44a4.171 4.171 0 0 0-1.776.41 5.047 5.047 0 0 0-1.609 1.208V7.709a5.969 5.969 0 0 1 3.812-1.272zm-1.577 7.379a1.135 1.135 0 0 0 .341.862 1.18 1.18 0 0 0 .846.326 2.546 2.546 0 0 0 1.7-.778V11.64a12.06 12.06 0 0 0-1.7.694 3.107 3.107 0 0 0-.9.662 1.212 1.212 0 0 0-.287.82z",
    transform: "translate(-20.197 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4327",
    d: "M106.595 3.321h.21v2.607h3.363v1.954h-3.363v4.53a1.393 1.393 0 0 0 1.492 1.482 4.423 4.423 0 0 0 2.081-.652v2.07a6.489 6.489 0 0 1-2.628.62 3.562 3.562 0 0 1-2.591-.9 3.262 3.262 0 0 1-.93-2.449v-4.7h-1.534v-.42z",
    transform: "translate(-23.043 -.745)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4328",
    d: "M106.595 3.321h.21v2.607h3.363v1.954h-3.363v4.53a1.393 1.393 0 0 0 1.492 1.482 4.423 4.423 0 0 0 2.081-.652v2.07a6.489 6.489 0 0 1-2.628.62 3.562 3.562 0 0 1-2.591-.9 3.262 3.262 0 0 1-.93-2.449v-4.7h-1.534v-.42z",
    transform: "translate(-23.043 -.745)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4329",
    d: "M118.744 6.437a4.4 4.4 0 0 1 3.427 1.388 5.5 5.5 0 0 1 1.261 3.837v.389h-6.948a3.023 3.023 0 0 0 .983 2.023 3.36 3.36 0 0 0 2.265.71 5.033 5.033 0 0 0 1.782-.32 7.74 7.74 0 0 0 1.772-.973v1.924a7.054 7.054 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.8-1.4 4.892 4.892 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.368-3.658 4.692 4.692 0 0 1 3.548-1.419M121 10.484a2.84 2.84 0 0 0-.652-1.677 1.926 1.926 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.848 2.848 0 0 0-.751 1.7z",
    transform: "translate(-25.543 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4330",
    d: "M118.744 6.437a4.4 4.4 0 0 1 3.427 1.388 5.5 5.5 0 0 1 1.261 3.837v.389h-6.948a3.023 3.023 0 0 0 .983 2.023 3.36 3.36 0 0 0 2.265.71 5.033 5.033 0 0 0 1.782-.32 7.74 7.74 0 0 0 1.772-.973v1.924a7.054 7.054 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.8-1.4 4.892 4.892 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.368-3.658 4.692 4.692 0 0 1 3.544-1.419zM121 10.484a2.84 2.84 0 0 0-.652-1.677 1.926 1.926 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.848 2.848 0 0 0-.751 1.7z",
    transform: "translate(-25.543 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4331",
    d: "M146.445.407v2.217h-6.653v3.858h6.37V8.7h-6.37v4.173h6.8v2.218h-9.638V.407z",
    transform: "translate(-30.73 -.092)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4332",
    d: "M146.445.407v2.217h-6.653v3.858h6.37V8.7h-6.37v4.173h6.8v2.218h-9.638V.407z",
    transform: "translate(-30.73 -.092)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4333",
    d: "M158.063 6.437a3.344 3.344 0 0 1 1.919.531 3.247 3.247 0 0 1 1.171 1.424 6.1 6.1 0 0 1 1.656-1.492 3.611 3.611 0 0 1 1.813-.468 3.293 3.293 0 0 1 2.512 1.015 3.781 3.781 0 0 1 .957 2.706v6.286h-2.586v-5.85a2.646 2.646 0 0 0-.437-1.608 1.479 1.479 0 0 0-1.267-.589 2.965 2.965 0 0 0-2.28 1.524v6.527h-2.575v-5.9a2.457 2.457 0 0 0-.463-1.582 1.512 1.512 0 0 0-1.24-.572 2 2 0 0 0-1.156.362 5.2 5.2 0 0 0-1.125 1.162v6.527h-2.585V6.626h2.585V8a5.174 5.174 0 0 1 1.43-1.183 3.516 3.516 0 0 1 1.671-.384",
    transform: "translate(-34.191 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4334",
    d: "M158.063 6.437a3.344 3.344 0 0 1 1.919.531 3.247 3.247 0 0 1 1.171 1.424 6.1 6.1 0 0 1 1.656-1.492 3.611 3.611 0 0 1 1.813-.468 3.293 3.293 0 0 1 2.512 1.015 3.781 3.781 0 0 1 .957 2.706v6.286h-2.586v-5.85a2.646 2.646 0 0 0-.437-1.608 1.479 1.479 0 0 0-1.267-.589 2.965 2.965 0 0 0-2.28 1.524v6.527h-2.575v-5.9a2.457 2.457 0 0 0-.463-1.582 1.512 1.512 0 0 0-1.24-.572 2 2 0 0 0-1.156.362 5.2 5.2 0 0 0-1.125 1.162v6.527h-2.585V6.626h2.585V8a5.174 5.174 0 0 1 1.43-1.183 3.516 3.516 0 0 1 1.671-.38z",
    transform: "translate(-34.191 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4335",
    d: "M180.917 6.438a4.376 4.376 0 0 1 3.389 1.408 5.229 5.229 0 0 1 1.287 3.669 5.676 5.676 0 0 1-.6 2.649 4.413 4.413 0 0 1-1.719 1.819 4.9 4.9 0 0 1-2.522.652 5.1 5.1 0 0 1-2.3-.579v5.34h-2.586V6.627h2.565v.631a4.253 4.253 0 0 1 2.491-.82m-2.47 7.725a3.651 3.651 0 0 0 1.808.557 2.43 2.43 0 0 0 1.955-.872 3.376 3.376 0 0 0 .735-2.25 3.767 3.767 0 0 0-.657-2.354 2.218 2.218 0 0 0-1.865-.852 2.539 2.539 0 0 0-.873.153 4.966 4.966 0 0 0-1.1.646z",
    transform: "translate(-39.461 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4336",
    d: "M180.917 6.438a4.376 4.376 0 0 1 3.389 1.408 5.229 5.229 0 0 1 1.287 3.669 5.676 5.676 0 0 1-.6 2.649 4.413 4.413 0 0 1-1.719 1.819 4.9 4.9 0 0 1-2.522.652 5.1 5.1 0 0 1-2.3-.579v5.34h-2.586V6.627h2.565v.631a4.253 4.253 0 0 1 2.486-.82zm-2.47 7.725a3.651 3.651 0 0 0 1.808.557 2.43 2.43 0 0 0 1.955-.872 3.376 3.376 0 0 0 .735-2.25 3.767 3.767 0 0 0-.657-2.354 2.218 2.218 0 0 0-1.865-.852 2.539 2.539 0 0 0-.873.153 4.966 4.966 0 0 0-1.1.646z",
    transform: "translate(-39.461 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5875",
    transform: "translate(148.278 .315)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h2.586v14.684H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5876",
    transform: "translate(148.278 .315)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    },
    d: "M0 0h2.586v14.684H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4337",
    d: "M202.668 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.617 4.617 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.753-.636M200 11.493a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.4 3.4 0 0 0-.735 2.281",
    transform: "translate(-44.268 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4338",
    d: "M202.668 6.437a6.016 6.016 0 0 1 2.785.641 4.66 4.66 0 0 1 1.934 1.8 5.045 5.045 0 0 1 .683 2.618 5.276 5.276 0 0 1-.656 2.67 4.606 4.606 0 0 1-1.934 1.808 6.016 6.016 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.617 4.617 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.948 5.948 0 0 1 2.754-.639zM200 11.493a3.6 3.6 0 0 0 .72 2.349 2.368 2.368 0 0 0 1.929.877 2.487 2.487 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.4 3.4 0 0 0-.735 2.281z",
    transform: "translate(-44.268 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4339",
    d: "m215.016 6.681 2.323 5.276 2.354-5.276h2.775l-6.78 14.768h-2.774l3.121-6.759-3.814-8.009z",
    transform: "translate(-47.619 -1.499)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4340",
    d: "m215.016 6.681 2.323 5.276 2.354-5.276h2.775l-6.78 14.768h-2.774l3.121-6.759-3.814-8.009z",
    transform: "translate(-47.619 -1.499)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4341",
    d: "M231.372 6.437a4.4 4.4 0 0 1 3.428 1.388 5.492 5.492 0 0 1 1.262 3.837v.389h-6.948a3.026 3.026 0 0 0 .982 2.023 3.362 3.362 0 0 0 2.266.71 5.033 5.033 0 0 0 1.782-.32 7.736 7.736 0 0 0 1.771-.973v1.924a7.05 7.05 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.794-1.4 4.89 4.89 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.361-3.658 4.692 4.692 0 0 1 3.547-1.419m2.26 4.047a2.845 2.845 0 0 0-.651-1.677 1.927 1.927 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.853 2.853 0 0 0-.751 1.7z",
    transform: "translate(-50.815 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4342",
    d: "M231.372 6.437a4.4 4.4 0 0 1 3.428 1.388 5.492 5.492 0 0 1 1.262 3.837v.389h-6.948a3.026 3.026 0 0 0 .982 2.023 3.362 3.362 0 0 0 2.266.71 5.033 5.033 0 0 0 1.782-.32 7.736 7.736 0 0 0 1.771-.973v1.924a7.05 7.05 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.794-1.4 4.89 4.89 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.361-3.658 4.692 4.692 0 0 1 3.544-1.419zm2.26 4.047a2.845 2.845 0 0 0-.651-1.677 1.927 1.927 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.853 2.853 0 0 0-.751 1.7z",
    transform: "translate(-50.815 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4343",
    d: "M245.7 6.437a4.4 4.4 0 0 1 3.427 1.388 5.492 5.492 0 0 1 1.262 3.837v.389h-6.948a3.026 3.026 0 0 0 .982 2.023 3.362 3.362 0 0 0 2.266.71 5.033 5.033 0 0 0 1.782-.32 7.737 7.737 0 0 0 1.771-.973v1.924a7.05 7.05 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.794-1.4 4.89 4.89 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.361-3.658 4.692 4.692 0 0 1 3.545-1.419m2.26 4.047a2.845 2.845 0 0 0-.651-1.677 1.927 1.927 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.853 2.853 0 0 0-.752 1.7z",
    transform: "translate(-54.029 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4344",
    d: "M245.7 6.437a4.4 4.4 0 0 1 3.427 1.388 5.492 5.492 0 0 1 1.262 3.837v.389h-6.948a3.026 3.026 0 0 0 .982 2.023 3.362 3.362 0 0 0 2.266.71 5.033 5.033 0 0 0 1.782-.32 7.737 7.737 0 0 0 1.771-.973v1.924a7.05 7.05 0 0 1-4.183 1.22 5.284 5.284 0 0 1-3.794-1.4 4.89 4.89 0 0 1-1.471-3.721 5.065 5.065 0 0 1 1.361-3.658 4.692 4.692 0 0 1 3.545-1.419zm2.26 4.047a2.845 2.845 0 0 0-.651-1.677 1.927 1.927 0 0 0-1.5-.6 2.159 2.159 0 0 0-1.571.578 2.853 2.853 0 0 0-.752 1.7z",
    transform: "translate(-54.029 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4345",
    d: "M267.945.163a8.59 8.59 0 0 1 4.131 1.072v2.523a8.081 8.081 0 0 0-4.047-1.377 2.93 2.93 0 0 0-1.676.416 1.284 1.284 0 0 0-.6 1.109q0 .83 1.125 1.534.315.211 2.428 1.177a6.968 6.968 0 0 1 2.607 1.892 3.987 3.987 0 0 1 .8 2.5 3.819 3.819 0 0 1-1.362 3.054 5.245 5.245 0 0 1-3.526 1.162 8.358 8.358 0 0 1-2.423-.31 10.533 10.533 0 0 1-2.276-1.066v-2.8a7.134 7.134 0 0 0 4.436 1.955 2.86 2.86 0 0 0 1.682-.451 1.4 1.4 0 0 0 .641-1.2 1.894 1.894 0 0 0-1.12-1.653q-.926-.5-2.387-1.209a7.009 7.009 0 0 1-2.591-1.84 3.743 3.743 0 0 1-.857-2.439 3.576 3.576 0 0 1 1.377-2.948 5.659 5.659 0 0 1 3.636-1.1",
    transform: "translate(-58.998 -.037)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4346",
    d: "M267.945.163a8.59 8.59 0 0 1 4.131 1.072v2.523a8.081 8.081 0 0 0-4.047-1.377 2.93 2.93 0 0 0-1.676.416 1.284 1.284 0 0 0-.6 1.109q0 .83 1.125 1.534.315.211 2.428 1.177a6.968 6.968 0 0 1 2.607 1.892 3.987 3.987 0 0 1 .8 2.5 3.819 3.819 0 0 1-1.362 3.054 5.245 5.245 0 0 1-3.526 1.162 8.358 8.358 0 0 1-2.423-.31 10.533 10.533 0 0 1-2.276-1.066v-2.8a7.134 7.134 0 0 0 4.436 1.955 2.86 2.86 0 0 0 1.682-.451 1.4 1.4 0 0 0 .641-1.2 1.894 1.894 0 0 0-1.12-1.653q-.926-.5-2.387-1.209a7.009 7.009 0 0 1-2.591-1.84 3.743 3.743 0 0 1-.857-2.439 3.576 3.576 0 0 1 1.377-2.948 5.659 5.659 0 0 1 3.638-1.101z",
    transform: "translate(-58.998 -.037)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4347",
    d: "M283.029 6.437a6.014 6.014 0 0 1 2.785.641 4.667 4.667 0 0 1 1.934 1.8 5.052 5.052 0 0 1 .683 2.618 5.276 5.276 0 0 1-.657 2.67 4.606 4.606 0 0 1-1.934 1.808 6.014 6.014 0 0 1-2.812.662 5.944 5.944 0 0 1-2.806-.662 4.622 4.622 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.72 4.72 0 0 1 1.934-1.787 5.953 5.953 0 0 1 2.753-.636m-2.67 5.056a3.591 3.591 0 0 0 .721 2.349 2.365 2.365 0 0 0 1.928.877 2.486 2.486 0 0 0 1.994-.843 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.391 3.391 0 0 0-.736 2.281",
    transform: "translate(-62.3 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4348",
    d: "M283.029 6.437a6.014 6.014 0 0 1 2.785.641 4.667 4.667 0 0 1 1.934 1.8 5.052 5.052 0 0 1 .683 2.618 5.276 5.276 0 0 1-.657 2.67 4.606 4.606 0 0 1-1.934 1.808 6.014 6.014 0 0 1-2.812.662 5.944 5.944 0 0 1-2.806-.662 4.622 4.622 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.72 4.72 0 0 1 1.934-1.787 5.953 5.953 0 0 1 2.755-.639zm-2.67 5.056a3.591 3.591 0 0 0 .721 2.349 2.365 2.365 0 0 0 1.928.877 2.486 2.486 0 0 0 1.992-.84 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.391 3.391 0 0 0-.739 2.28z",
    transform: "translate(-62.3 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5877",
    transform: "translate(228.288 .315)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h2.586v14.684H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5878",
    transform: "translate(228.288 .315)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    },
    d: "M0 0h2.586v14.684H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4349",
    d: "M303.573 6.681v6.075a2.026 2.026 0 0 0 .478 1.456 1.673 1.673 0 0 0 1.267.5 2.218 2.218 0 0 0 1.251-.4 2.877 2.877 0 0 0 .966-1.124V6.681h2.586V16.5h-2.586v-1.337a4.083 4.083 0 0 1-3.026 1.524 3.327 3.327 0 0 1-2.543-1.03 3.769 3.769 0 0 1-.966-2.69V6.681z",
    transform: "translate(-67.539 -1.499)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4350",
    d: "M303.573 6.681v6.075a2.026 2.026 0 0 0 .478 1.456 1.673 1.673 0 0 0 1.267.5 2.218 2.218 0 0 0 1.251-.4 2.877 2.877 0 0 0 .966-1.124V6.681h2.586V16.5h-2.586v-1.337a4.083 4.083 0 0 1-3.026 1.524 3.327 3.327 0 0 1-2.543-1.03 3.769 3.769 0 0 1-.966-2.69V6.681z",
    transform: "translate(-67.539 -1.499)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4351",
    d: "M318.435 3.321h.21v2.607h3.364v1.954h-3.364v4.53a1.394 1.394 0 0 0 1.492 1.482 4.423 4.423 0 0 0 2.082-.652v2.07a6.49 6.49 0 0 1-2.628.62 3.562 3.562 0 0 1-2.591-.9 3.259 3.259 0 0 1-.93-2.449v-4.7h-1.534v-.42z",
    transform: "translate(-70.577 -.745)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4352",
    d: "M318.435 3.321h.21v2.607h3.364v1.954h-3.364v4.53a1.394 1.394 0 0 0 1.492 1.482 4.423 4.423 0 0 0 2.082-.652v2.07a6.49 6.49 0 0 1-2.628.62 3.562 3.562 0 0 1-2.591-.9 3.259 3.259 0 0 1-.93-2.449v-4.7h-1.534v-.42z",
    transform: "translate(-70.577 -.745)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4353",
    d: "M327.692.827a1.407 1.407 0 0 1 1.03.43 1.407 1.407 0 0 1 .431 1.03 1.447 1.447 0 0 1-.426 1.025 1.412 1.412 0 0 1-2.06 0 1.427 1.427 0 0 1-.437-1.025 1.383 1.383 0 0 1 .442-1.035 1.425 1.425 0 0 1 1.019-.425m1.293 14.357H326.4V5.367h2.586z",
    transform: "translate(-73.201 -.186)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4354",
    d: "M327.692.827a1.407 1.407 0 0 1 1.03.43 1.407 1.407 0 0 1 .431 1.03 1.447 1.447 0 0 1-.426 1.025 1.412 1.412 0 0 1-2.06 0 1.427 1.427 0 0 1-.437-1.025 1.383 1.383 0 0 1 .442-1.035 1.425 1.425 0 0 1 1.02-.425zm1.293 14.357H326.4V5.367h2.586z",
    transform: "translate(-73.201 -.186)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4355",
    d: "M337.941 6.437a6.014 6.014 0 0 1 2.785.641 4.667 4.667 0 0 1 1.934 1.8 5.052 5.052 0 0 1 .683 2.618 5.277 5.277 0 0 1-.657 2.67 4.606 4.606 0 0 1-1.934 1.808 6.014 6.014 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.623 4.623 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.953 5.953 0 0 1 2.753-.636m-2.67 5.056a3.592 3.592 0 0 0 .721 2.349 2.365 2.365 0 0 0 1.928.877 2.486 2.486 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.391 3.391 0 0 0-.736 2.281",
    transform: "translate(-74.622 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4356",
    d: "M337.941 6.437a6.014 6.014 0 0 1 2.785.641 4.667 4.667 0 0 1 1.934 1.8 5.052 5.052 0 0 1 .683 2.618 5.277 5.277 0 0 1-.657 2.67 4.606 4.606 0 0 1-1.934 1.808 6.014 6.014 0 0 1-2.812.662 5.945 5.945 0 0 1-2.806-.662 4.623 4.623 0 0 1-1.918-1.808 5.268 5.268 0 0 1-.657-2.67 5 5 0 0 1 .693-2.633 4.719 4.719 0 0 1 1.934-1.787 5.953 5.953 0 0 1 2.755-.639zm-2.67 5.056a3.592 3.592 0 0 0 .721 2.349 2.365 2.365 0 0 0 1.928.877 2.486 2.486 0 0 0 1.987-.841 3.579 3.579 0 0 0 .724-2.407 3.339 3.339 0 0 0-.73-2.307 2.529 2.529 0 0 0-1.982-.814 2.4 2.4 0 0 0-1.913.862 3.391 3.391 0 0 0-.734 2.281z",
    transform: "translate(-74.622 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4357",
    d: "M354.82 6.437a3.235 3.235 0 0 1 2.518 1.035 3.9 3.9 0 0 1 .941 2.728v6.243H355.7v-5.981a2.317 2.317 0 0 0-.458-1.513A1.525 1.525 0 0 0 354 8.392a1.984 1.984 0 0 0-1.125.352 5.27 5.27 0 0 0-1.156 1.172v6.527h-2.586V6.626h2.586V8a4.591 4.591 0 0 1 1.466-1.2 3.706 3.706 0 0 1 1.634-.363",
    transform: "translate(-78.341 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4358",
    d: "M354.82 6.437a3.235 3.235 0 0 1 2.518 1.035 3.9 3.9 0 0 1 .941 2.728v6.243H355.7v-5.981a2.317 2.317 0 0 0-.458-1.513A1.525 1.525 0 0 0 354 8.392a1.984 1.984 0 0 0-1.125.352 5.27 5.27 0 0 0-1.156 1.172v6.527h-2.586V6.626h2.586V8a4.591 4.591 0 0 1 1.466-1.2 3.706 3.706 0 0 1 1.635-.363z",
    transform: "translate(-78.341 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4359",
    d: "M367.185 6.437a6.1 6.1 0 0 1 1.524.184 7.776 7.776 0 0 1 1.513.583v2.071a7.256 7.256 0 0 0-1.577-.762 4.676 4.676 0 0 0-1.5-.289 1.568 1.568 0 0 0-.873.21.679.679 0 0 0-.315.6.6.6 0 0 0 .263.442 9.9 9.9 0 0 0 1.44.809 8.8 8.8 0 0 1 2.359 1.571 2.433 2.433 0 0 1 .679 1.729 2.737 2.737 0 0 1-.988 2.234 4.073 4.073 0 0 1-2.67.815 7.924 7.924 0 0 1-1.961-.232 6.586 6.586 0 0 1-1.508-.557V13.69a6.924 6.924 0 0 0 3.185 1.051 2.133 2.133 0 0 0 1.072-.237.7.7 0 0 0 .41-.625.669.669 0 0 0-.147-.42 1.934 1.934 0 0 0-.441-.389q-.294-.2-1.839-.956a5.254 5.254 0 0 1-1.756-1.235 2.368 2.368 0 0 1-.568-1.582 2.486 2.486 0 0 1 1.02-2.081 4.3 4.3 0 0 1 2.681-.778",
    transform: "translate(-81.561 -1.445)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4360",
    d: "M367.185 6.437a6.1 6.1 0 0 1 1.524.184 7.776 7.776 0 0 1 1.513.583v2.071a7.256 7.256 0 0 0-1.577-.762 4.676 4.676 0 0 0-1.5-.289 1.568 1.568 0 0 0-.873.21.679.679 0 0 0-.315.6.6.6 0 0 0 .263.442 9.9 9.9 0 0 0 1.44.809 8.8 8.8 0 0 1 2.359 1.571 2.433 2.433 0 0 1 .679 1.729 2.737 2.737 0 0 1-.988 2.234 4.073 4.073 0 0 1-2.67.815 7.924 7.924 0 0 1-1.961-.232 6.586 6.586 0 0 1-1.508-.557V13.69a6.924 6.924 0 0 0 3.185 1.051 2.133 2.133 0 0 0 1.072-.237.7.7 0 0 0 .41-.625.669.669 0 0 0-.147-.42 1.934 1.934 0 0 0-.441-.389q-.294-.2-1.839-.956a5.254 5.254 0 0 1-1.756-1.235 2.368 2.368 0 0 1-.568-1.582 2.486 2.486 0 0 1 1.02-2.081 4.3 4.3 0 0 1 2.678-.779z",
    transform: "translate(-81.561 -1.445)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: ".326px",
      stroke: "#231f20",
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4371",
    d: "M7.95-9.913C3.428-9.913.735-7.322.735-3.384c0 3.963 2.693 6.656 7.24 6.656a12.357 12.357 0 0 0 5.919-1.346V-.869A11.668 11.668 0 0 1 8.915.4a3.546 3.546 0 0 1-3.582-2.641h8.891v-.915c0-4.572-2.896-6.757-6.274-6.757zM5.206-4.451A2.473 2.473 0 0 1 7.7-7.144c1.448 0 2.337 1.016 2.337 2.693zm17.2-10.06c-4.166 0-6.2 2.261-6.2 5 0 3.429 3.074 4.75 4.674 5.487 2.49 1.092 2.845 1.55 2.845 2.286 0 .584-.508 1.27-2.108 1.27a9.446 9.446 0 0 1-5.258-1.905V1.9a15.63 15.63 0 0 0 6.071 1.372c3.785 0 6.478-2.007 6.478-5.258 0-3.15-2.642-4.42-5.182-5.614-1.906-.89-2.516-1.3-2.516-2.059 0-.711.508-1.3 1.854-1.3a8.972 8.972 0 0 1 5.106 1.981v-4.09a11.858 11.858 0 0 0-5.77-1.443zm17.96 4.6a5.638 5.638 0 0 0-4.471 2.058v-6.427h-4.473V3.043h4.471v-7.469c.915-1.423 1.778-2.007 2.718-2.007 1.219 0 1.829.889 1.829 2.413v7.063h4.471v-7.8c0-2.943-1.143-5.156-4.547-5.156zM54.285-6.56c1.651 0 2.566 1.219 2.566 3.226 0 2.058-.94 3.252-2.54 3.252-1.626 0-2.54-1.219-2.54-3.252-.001-2.057.964-3.226 2.514-3.226zm.025-3.353c-4.725 0-7.24 2.769-7.24 6.579 0 3.836 2.54 6.6 7.24 6.6 4.674 0 7.24-2.769 7.24-6.6 0-3.785-2.515-6.579-7.24-6.579zm22.914 6.732c0-5.817-3.683-6.5-7.189-6.5h-6.2V8.835h4.471v-6.4a5.482 5.482 0 0 0 3.175.838c4.019-.002 5.743-3.33 5.743-6.454zm-8.917-3.15h1.524c1.55 0 2.693 1.092 2.693 3.1 0 1.981-.762 3.15-2.21 3.15a3.12 3.12 0 0 1-2.007-.66z",
    transform: "translate(105.265 152.84)",
    style: {
      fill: "#333"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEShopLogoLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eShopLogo-large.18e1719fb152715b955d20e4315ca2a8.svg";